import React from "react";
import {useTranslation} from "react-i18next";
import HandySignSigning from "assets/images/svg/handysign-signing";

const SignContractsNullStateContent = () => {
  const {t} = useTranslation();

  return (
    <div className="df-row-jcc-center mt-16 mb-8">
      <HandySignSigning />
      <div className="ml-8">
        <h1 className="fz-30 __bold mb-0">{t("SIGN_CONTRACTS_NULL_STATE_HEADER")}</h1>
        <div className="df-row-center">
          <div>{t("SIGN_CONTRACTS_NULL_STATE_BULLET_1")}</div>
          <div className="ml-4">{t("SIGN_CONTRACTS_NULL_STATE_BULLET_2")}</div>
        </div>
        <div className="__caveat fz-20">{t("SIGN_CONTRACTS_NULL_STATE_CTA")}</div>
      </div>
    </div>
  );
};

export default SignContractsNullStateContent;
